module.exports = __webpack_public_path__ + "../resources/img/ic_error.eacb2bde.svg";